
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const HeroVisualization = () => {
  return (
    <Card className="cyber-card border-primary/20 backdrop-blur-sm">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-primary">
          Platform Activity
        </CardTitle>
        <div className="status-active pl-4">
          <span className="text-xs text-green-400">OPERATIONAL</span>
        </div>
      </CardHeader>
      <CardContent>
        <div className="h-48 w-full rounded-md bg-black/30 p-2 overflow-hidden">
          <div className="font-mono text-xs text-green-400/80 animate-log-scroll">
            <p>[STATUS] Monitoring active</p>
            <p>[SCAN] WordPress exposure review completed</p>
            <p className="text-yellow-400/80">[WARN] Plugin risk intelligence updated</p>
            <p>[AUTH] Repeated login failures detected</p>
            <p className="text-red-400/80">[ALERT] Suspicious file change queued for analyst review</p>
            <p>[REVIEW] Analyst validation in progress</p>
            <p>[ACTION] Remediation guidance prepared</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default HeroVisualization;
